import type Proposal from "work/proposals/proposal";

/**
 * Whether the pane offers the negotiation, the conversation both parties read. Before a proposal is
 * submitted its own party is the only one at the table: the team leader and reviewers talk among
 * themselves, and there is nobody yet to negotiate with. A revision of hired work offers it from the
 * start, because both parties are already at the table and the revision's negotiation continues there.
 *
 * The answer comes from the proposal alone. Whether the reader may also read the negotiation a revision
 * continues decides only whether that earlier conversation is shown, never whether the revision's own
 * is: a reviewer added to the revision alone would otherwise lose it (#6515).
 *
 * A page that counts unread comments or stops at them asks this too, so it never counts or stops at a
 * conversation the pane will not open (#6515).
 */
export function offersNegotiation(
  proposal: Pick<Proposal, "isSubmitted" | "revisesHiredWorkAgreement"> | null | undefined,
): boolean {
  return Boolean(proposal?.isSubmitted || proposal?.revisesHiredWorkAgreement);
}
